import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import toast from 'react-hot-toast';

import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import { resetChangeFaceVal } from '../../Redux/action/interactions';
import { useSelector, useDispatch } from 'react-redux';
import classes from './ChangeFace.module.scss';
import { changeFace } from '../../API/API';

const ChangeFace = () => {
  const videoConstraints = {
    width: 300,
    height: 300,
    facingMode: 'user',
  };
  const [picture, setPicture] = useState(null);
  const [resetPic, setResetPic] = useState(false);
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const photoChangeState = useSelector(state => state.interactions.photoChangedMatch)

  const dispatch = useDispatch();

  useEffect(() => {
    const checkWebcamEnabled = async () => {
      try {
        // Access the webcam using the webcamRef
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      } catch (error) {
        // Webcam is not enabled
        toast("Webcam is not enabled!", {
          icon: '❗',
        });
        navigate('/dashboard/home');
      }
    };

    checkWebcamEnabled();
  }, [])

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    // Send the photo to the server for validation
    sendPhotoToServer(pictureSrc.substring(23));
    setPicture(pictureSrc);
  }, []);

  const sendPhotoToServer =
    (imageSrc) => {
      setResetPic(true);
      const userID = localStorage.getItem('userID');
      const data = JSON.parse(localStorage.getItem('data'));
      localStorage.setItem('Photo', imageSrc);
      const locData = JSON.parse(localStorage.getItem('data'));

      if (locData !== null) {
        let obj = { ...locData, photo: imageSrc }

        localStorage.setItem('data', JSON.stringify(obj))
      }


      dispatch(changeFace(userID, data.empid, data.token, imageSrc));

    }

  const changePic = (userID, empID, token, photo) => {
    navigate('/dashboard/home'); // Redirect to the home page

  };

  const recapture = () => {
    setResetPic(false);
    setPicture(null);

  };

  return (
    <>
      <BreadCrumb name="Register Face" />
      <div className={classes.ChangeFace}>
        <div className={classes.ChangeFaceDiv}>
          <h2 style={{ textAlign: 'center', fontSize:"18px" , }}>
            Please Make Sure That The Background is Clear
          </h2>
          {picture !== null ? (
            <img src={picture} alt="Capture" />
          ) : (
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ width: '100%', borderRadius: '10px' }}
            />
          )}
          <div className={classes.CaptureButton}>
            {resetPic ? (

              photoChangeState ? (
                <div className={classes.ConfirmationDiv}>
                  <h3>Photo has been Changed !!</h3>
                  <div className={classes.YesNoDiv}>
                    <button className={classes.YesButton} onClick={changePic}>
                      Ok
                    </button>
                  </div>
                </div>
              ) : (
                <div className={classes.ConfirmationDiv}>
                  <h3>Make sure to keep your phone at least one foot away from your face while taking the photo,
                    and ensure that there is no one in the background.</h3>
                  <div className={classes.YesNoDiv}>
                    <button className={classes.YesButton} onClick={recapture}>
                      Retake
                    </button>
                  </div>
                </div>
              )
            ) : (
              <button onClick={capture}>Change Profile Picture</button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeFace;
